import { gsap } from "gsap";

function uspCarousel($items) {
	const uspItems = document.querySelectorAll($items);

	if (uspItems.length) {
		let timeline = null;

		function createAnimation() {
			if (timeline) {
				timeline.kill();
			}

			gsap.set(uspItems, { xPercent: 100, opacity: 0 });

			timeline = gsap.timeline({ repeat: -1 });

			uspItems.forEach((item) => {
				timeline.to(item, {
					xPercent: 0,
					opacity: 1,
					duration: 0.5,
					ease: "power2.out",
				});

				timeline.to(item, {
					duration: 2,
				});

				timeline.to(item, {
					xPercent: -100,
					opacity: 0,
					duration: 0.5,
					ease: "power2.in",
				});
			});
		}

		function handleResize() {
			if (window.innerWidth < 1008) {
				if (!timeline) {
					createAnimation();
				}
			} else {
				if (timeline) {
					timeline.kill();
					timeline = null;
					gsap.set(uspItems, { xPercent: 0, opacity: 1 });
				}
			}
		}

		handleResize();

		window.addEventListener('resize', handleResize);
	}
}

export default uspCarousel;
